import styled from 'styled-components';

import { CALLOUT_FLAIR_COLOURS } from '@belong/themes';

import { Icon } from '../../../Icon';

export const DifferentiatorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
`;

export const DifferentiatorTab = styled.div<{ background: string; isDesktopViewport: boolean }>`
  border-radius: 0.8rem 0.8rem 0 0;
  background: ${({ background }) => CALLOUT_FLAIR_COLOURS[background]};
  background-size: 200%;
  background-position: center;
  margin: 0 auto;
  padding: ${({ isDesktopViewport }) =>
    isDesktopViewport ? '0.8rem 1.6rem 0.8rem 1.2rem' : '0.4rem 1.2rem 0.4rem 0.8rem'};
  display: flex;
  align-items: center;
`;

export const DifferentiatorIcon = styled(Icon)`
  margin-right: 0.5rem;
`;
